import { Link, useRouteError } from "react-router-dom";
import { Home, RefreshCcw, AlertTriangle } from "lucide-react";
import { Button, Row, Col, Typography } from "antd";
import ReportErrorButton from "Components/ReportErrorButton/ReportErrorButton";
import { normalizeReportError } from "hooks/useReportError/useReportError";

const { Title, Text, Paragraph } = Typography;

function ServerError() {
  const routeError = useRouteError();
  const normalized = normalizeReportError(routeError);
  const errorMessage = normalized?.message ?? (typeof routeError === "string" ? routeError : null);

  return (
    <Row justify="center" align="middle" style={{ minHeight: "100vh" }} className="bg-background px-4">
      <Col xs={24} sm={20} md={14} lg={10} xl={8} className="text-center">
        <Row gutter={[0, 32]} justify="center">

          {/* Icon + heading */}
          <Col span={24}>
            <Row gutter={[0, 16]} justify="center">
              <Col span={24}>
                <div className="mx-auto h-16 w-16 rounded-full bg-destructive/10 flex items-center justify-center">
                  <AlertTriangle className="h-8 w-8 text-destructive" />
                </div>
              </Col>
              <Col span={24}>
                <Text className="text-6xl font-extrabold tracking-tighter text-destructive block">
                  500
                </Text>
              </Col>
              <Col span={24}>
                <Title level={3} style={{ margin: 0 }}>Something went wrong</Title>
              </Col>
              <Col span={24}>
                <Paragraph type="secondary" className="text-sm leading-relaxed" style={{ margin: 0 }}>
                  {errorMessage ?? "We're experiencing an internal server error. Please try again in a few moments."}
                </Paragraph>
              </Col>
            </Row>
          </Col>

          {/* Actions */}
          <Col span={24}>
            <Row justify="center" gutter={[12, 12]}>
              <Col>
                <Button icon={<RefreshCcw className="h-4 w-4" />} onClick={() => window.location.reload()}>
                  Try Again
                </Button>
              </Col>
              <Col>
                <Button icon={<Home className="h-4 w-4" />}>
                  <Link to="/shoup-community/dashboard">Go to Dashboard</Link>
                </Button>
              </Col>
              <Col>
                <ReportErrorButton error={routeError} context="500 — Server Error" />
              </Col>
            </Row>
          </Col>

          {/* Footer */}
          <Col span={24} className="pt-4 border-t border-border/50">
            <Text type="secondary" className="text-xs">
              Error ID: {Math.random().toString(36).substring(2, 10).toUpperCase()} — If the problem
              persists, please contact support with this ID.
            </Text>
          </Col>

        </Row>
      </Col>
    </Row>
  );
}

export default ServerError;

